import { FETCH_TRAINER_APPLIES, FETCH_TRAINER_APPLY, APPROVE_TRAINER_APPLY } from './types';

export default {
    [FETCH_TRAINER_APPLIES](state, payload) {
        state.trainer_applies = payload;
    },
    [FETCH_TRAINER_APPLY](state, payload) {
        state.trainer_apply = payload;
    },
    [APPROVE_TRAINER_APPLY](state, payload) {
        state.trainer = payload;
    },
};



// WEBPACK FOOTER //
// ./src/store/trainer_apply/mutations.js